require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./alternatives-to-juvenile-detention.json") })
        }
      }, "path---alternatives-to-juvenile-detention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---alternatives-to-juvenile-detention!./.cache/json/alternatives-to-juvenile-detention.json
// module id = 839
// module chunks = 231608221292675